// PBKDF2 password hashing via Web Crypto API.
// Passwords are never stored or compared in plaintext.
// Uses 100,000 iterations of PBKDF2-HMAC-SHA256 with a per-user salt.

const ITERATIONS = 100_000;
const KEY_LENGTH = 256; // bits

export async function hashPassword(password, salt) {
  const keyMaterial = await crypto.subtle.importKey(
    "raw", new TextEncoder().encode(password), "PBKDF2", false, ["deriveBits"]
  );
  const bits = await crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: new TextEncoder().encode(salt), iterations: ITERATIONS, hash: "SHA-256" },
    keyMaterial, KEY_LENGTH
  );
  return Array.from(new Uint8Array(bits)).map(b => b.toString(16).padStart(2, "0")).join("");
}

export async function verifyPassword(plaintext, salt, storedHash) {
  return (await hashPassword(plaintext, salt)) === storedHash;
}

// Pre-computed PBKDF2("123", "ametal-default-salt", 100000, 32, "SHA-256")
// Used in seed data so the source never contains a plaintext default password.
export const DEFAULT_SALT = "ametal-default-salt";
export const HASH_123 = "da554b5d7174b2ec713683dc1d875ef1e81a5b44cd463dc377dac33f34b4c01d";
